import { Col } from "antd";
import Colors from "assets/Colors";
import styled from "styled-components";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const MainContentContainer = styled.div`
  width: 97%;
  margin: auto auto;
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const ContainerViewIcons = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  pointer-events: ${ (props) => props.editing ? "auto" : "none" };
`;

const ContainerButtons = styled.div`
  width: 97%;
  display: flex;
  margin: 30px auto;
  gap: 15px;
`;

const ChartsContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  @media (min-width: 1390px) {
    flex-direction: row;
  }
`;

const FullScreen = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  background: white;
`;

const NoItemsContainer = styled.div`
  // height: 144px;
  display: grid;
  align-items: center;
  background: ${`${Colors.background_dividers}50`};
  width: 100%;
 height: 60vh;
`;

const NoItemsMessageCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${Colors.text_secondary};
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
`;

const squareTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.GREY2};
  border-radius: 5px;
  // padding: 10px;
  // margin: 10px;
  position: relative;
  margin-bottom: 10px;
  width: 100px;
  height: 100px;
`;

// const containerTables = styled.div`
//   background: ${Colors.GREY2};
// `;

// const containerTables =  styled.   {
//   background: Colors.GREY2,
// }


const containerTables = styled(Col)`
  display: flex;
  flex-direction: column;
  width: 30%;
  padding-left: 20px;
  pointer-events: ${ (props) => props.editing ? "auto" : "none" };
  @media (max-width: 768px) {
    padding-left: 0;
    margin-top: 20px;
  }
`;



const roundTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.GREY2};
  border-radius: 50%;
  // padding: 10px;
  // margin: 10px;
  position: relative;
  margin-bottom: 10px;
  width: 100px;
  height: 100px;
`;

const rectangleTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.GREY2};
  border-radius: 5px;
  // padding: 10px;
  // margin: 10px;
  position: relative;
  margin-bottom: 10px;
  width: ${ (props) => props.width ? props.width : '100%' };
  height: 100px;
`;

const wall = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.GREY2};
  border-radius: 5px;
  // padding: 10px;
  // margin: 10px;
  margin-bottom: 10px;
  width: 100%;
  height: 40px;
`;

const TextSelectorComponentTitle = styled.div`
  color: ${Colors.text_primary};
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  white-space: nowrap; 
  overflow: hidden; 
  text-overflow: ellipsis; 
  max-width: 90%;
`;
const TextSelectorComponent = styled.div`
  color: ${Colors.text_primary};
  font-weight: 300;
  font-size: 12px;
  line-height: 14px;
`;

export default {
  PageContainer,
  ChartsContainer,
  ContainerViewIcons,
  ContainerButtons,
  MainContentContainer,
  FullScreen,
  NoItemsContainer,
  NoItemsMessageCenter,
  containerTables,
  TextSelectorComponentTitle,
  TextSelectorComponent,
  squareTable,
  roundTable,
  rectangleTable,
  wall,
};
